import { Action } from "@ngrx/store";
import { LoggingState } from "./logging.reducer";
import { NgxLoggerLevel } from "ngx-logger";

export enum LoggingActionTypes {
  SetLoggingState = "[Logging] Set State",
  SetLogLevel = "[Logging] Set Log Level",
}

export class SetLogLevel implements Action {
  readonly type = LoggingActionTypes.SetLogLevel;
  constructor(public level: NgxLoggerLevel) {}
}

export class SetLoggingState implements Action {
  readonly type = LoggingActionTypes.SetLoggingState;
  constructor(public state: LoggingState) {}
}

export type LoggingActions = SetLoggingState | SetLogLevel;
